export default "__VITE_ASSET__0337956e__"